import React, { useEffect, useRef, useState } from "react";
import PaymentToken from "../../components/global/PaymentToken/PaymentToken";
import CustomSelect from "../../components/global/CustomSelect/CustomSelect";
import {
  invoiceSelector,
  setPayInoviceCCDetails,
  setPaymentInfoValue,
} from "../../features/invoice/invoiceSlice";
import { useDispatch, useSelector } from "react-redux";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import { manageBillingSelector } from "../../features/managebilling/manageBillingSlice";
import SelectFormField from "../../components/global/SelectFormField/SelectFormField";

const PaymentSelection = ({
  defaultMethod,
  values,
  setAltPaymentReq,
  setEftPaymentReq,
  setChequePaymentReq,
  paymentInformation,
  iframeRef,
  CCerror,
  index,
  uniquePaymentTypes,
  control,
  formvalues,
  setValue,
  setfinalCCArray,
  diffCCDetails,
  showPaymentMethodForm,
  setShowPaymentMethodForm,
  trigger,
  allBillingDetails,
  paymentMethod,
  t,
}) => {
  const [paymentMethodType, setPaymentMethodType] = useState("creditCard");
  const [token, setToken] = useState("");
  const [ccDialog, setCCDialog] = useState(false);
  const [creditCardRequest, setCreditCardRequest] = useState(false);
  const submissionRef = useRef();
  const { paymentInfoValue } = useSelector(invoiceSelector);
  const [paymentValue, setPaymentValue] = useState(null);

  const { userLogin } = useSelector(authLoginSelector);
  // const iframeRef = useRef([]);
  const monerisProfileId = "htZXPEPDT24R73U";
  const { firmIDAndName } = useSelector(manageBillingSelector);
  const [error, setError] = useState([]);

  const slicedMethod =
    defaultMethod?.length >= 18
      ? `${defaultMethod?.slice(0, 18)}.... ${defaultMethod?.slice(-4)}`
      : defaultMethod;

  const dispatch = useDispatch();

  const getErrorMessage = (codes) => {
    if (!codes) return "";

    const codeStr = Array.isArray(codes) ? codes.join("") : codes;

    if (
      codeStr.includes("945") &&
      codeStr.includes("944") &&
      codeStr.includes("943")
    )
      return t("invalidCCDetails");

    if (codeStr.includes("943")) return t("invalidCCError");
    if (codeStr.includes("944")) return t("invalidExpiryError");
    if (codeStr.includes("945")) return t("invalidCVVError");

    return t("invalidCCDetails");
  };

  const dropdownChange = (e, index) => {
    const updated =
      paymentInfoValue === null || paymentInfoValue?.length < 1
        ? []
        : [...paymentInfoValue];
    updated[index] = e;

    dispatch(setPaymentInfoValue(updated));
    setPaymentValue(e);
    setValue(`paymentInfoDropdown_${index}`, e);
    trigger(`paymentInfoDropdown_${index}`);
    setfinalCCArray((prevArray) => {
      const newArray = [...prevArray];
      newArray[index] = { vaultDataKey: e?.vaultDataKey };
      return newArray;
    });

    if (defaultMethod === "EFT") {
      setEftPaymentReq(false);
    } else if (defaultMethod === "Cheque") {
      setChequePaymentReq(false);
    }
  };

  const paymentOptions = paymentInformation()?.map((item, i) => {
    return {
      label: item.paymentMethod?.includes("Credit Card")
        ? `${item.paymentMethod} ${item.maskedCardNumber}`
        : `${item.paymentMethod} ${item.accountNo}`,
      value: item,
    };
  });

  const uniquePaymentOptions = Array.from(
    new Map(paymentOptions?.map((item) => [item.label, item])).values(),
  );

  useEffect(() => {
    if (uniquePaymentOptions?.length > 0) {
      setValue(
        `paymentInfoDropdown_${index}`,
        uniquePaymentOptions?.filter((x) => x.label === defaultMethod)[0]
          ?.value,
      );
      trigger(`paymentInfoDropdown_${index}`);
    }
  }, [defaultMethod, diffCCDetails, values, allBillingDetails]);

  const inputCSS =
    '&css_textbox=margin-bottom: 10px;border-radius: 4px; display: inline; margin-right: 20px; margin-left: 10px; border: 1px solid rgb(206, 212, 218);font-size: 0.875rem;width: auto;padding: 10px 12px;transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;font-family: "Roboto", "Helvetica", "Arial", sans-serif;&css_textbox:hover=display: inline;';
  const exp_label = "&exp_label=Expiry Date (MMYY)";

  const iQuery =
    "id=" +
    monerisProfileId +
    "&display_labels=2&pmmsg=true" +
    inputCSS +
    "&css_textbox_pan=width:280px;display:inline;margin-top:0px;margin-left:9px;height:41px;&enable_exp=1&css_textbox_exp=width:90px;margin-left:-11px;height:41px;display:inline;&enable_cvd=1&css_textbox_cvd=width:90px;display:inline;margin-left:-11px;height:41px;" +
    exp_label;

  return (
    <div>
      <h2 className="block font-bold mb-[10px] mt-[24px] px-[40px] w-[370px]">
        Payment Info
      </h2>
      {showPaymentMethodForm && showPaymentMethodForm?.length === 0 ? (
        <div
          className="flex gap-[16px] items-end px-[40px]"
          id="payment_method_added"
        >
          <div id="payment_added">
            <div className="custom__dropdown-wrapper w-[370px]">
              {/* <CustomSelect
                defaultValue={
                  <span className="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
                    {slicedMethod} - Default
                  </span>
                }
                onChange={(e) => {
                  dropdownChange(e, index);
                }}
                name={"paymentInfoDropdown"}
                options={uniquePaymentOptions}
                value={paymentValue}
                // currentValue={paymentValue || null}
                isDisabled={uniquePaymentOptions?.length === 1}
              /> */}
              <SelectFormField
                testId="paymentInfoDropdown"
                // label={t("paymentInfoDropdown")}
                options={uniquePaymentOptions}
                dropdownChange={(e) => dropdownChange(e, index)}
                control={control}
                //loading={(userLogin.isLawyer && !userLogin.internalUser) || loading}
                loading={uniquePaymentOptions?.length === 0}
                fieldName={`paymentInfoDropdown_${index}`}
                // errorMessage={
                //   errors.orderinglawyerornotary && t("RequiredFieldErrMsg")
                // }
                defaultOption={
                  <span className="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
                    {slicedMethod} - Default
                  </span>
                }
                ariaLabel="Ordering paymentInfoDropdown/Notary"
                labelClassNames="questionnaire font-semibold w-[482px]"
                selectClassNames="custom__dropdown-wrapper w-[388px]"
                currentValue={
                  values && values[`paymentInfoDropdown_${index}`]
                    ? values[`paymentInfoDropdown_${index}`]
                    : null
                }
              />
            </div>
          </div>
          <button
            type="button"
            className="!h-[40px] btn__icon w-[275px]"
            onClick={() => {
              if (Array.isArray(showPaymentMethodForm)) {
                const updated = [...showPaymentMethodForm];
                let found = false;

                const newForm = updated.map((obj) => {
                  if (defaultMethod in obj) {
                    found = true;
                    return { [defaultMethod]: true };
                  }
                  return obj;
                });

                if (!found) {
                  newForm.push({ [defaultMethod]: true });
                }

                setShowPaymentMethodForm(newForm);
              } else {
                setShowPaymentMethodForm([{ [defaultMethod]: true }]);
              }
              dropdownChange({}, index);
              if (defaultMethod?.trim() === "EFT") {
                setEftPaymentReq(false);
              } else if (defaultMethod?.trim() === "Cheque") {
                setChequePaymentReq(false);
              }
            }}
          >
            <span>Use different payment method</span>
          </button>
        </div>
      ) : showPaymentMethodForm &&
        showPaymentMethodForm?.length > 0 &&
        !showPaymentMethodForm.find((obj) => defaultMethod in obj)?.[
          defaultMethod
        ] ? (
        <div
          className="flex gap-[16px] items-end px-[40px]"
          id="payment_method_added"
        >
          <div id="payment_added">
            <div className="custom__dropdown-wrapper w-[370px]">
              {/* <CustomSelect
                defaultValue={
                  <span className="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
                    {slicedMethod} - Default
                  </span>
                }
                onChange={(e) => {
                  dropdownChange(e, index);
                }}
                name={"paymentInfoDropdown"}
                options={uniquePaymentOptions}
                value={paymentValue}
                // currentValue={paymentValue || null}
                isDisabled={uniquePaymentOptions?.length === 1}
              /> */}
              <SelectFormField
                testId="paymentInfoDropdown"
                // label={t("paymentInfoDropdown")}
                options={uniquePaymentOptions}
                dropdownChange={(e) => dropdownChange(e, index)}
                control={control}
                //loading={(userLogin.isLawyer && !userLogin.internalUser) || loading}
                //loading={loading}
                fieldName={`paymentInfoDropdown_${index}`}
                // errorMessage={
                //   errors.orderinglawyerornotary && t("RequiredFieldErrMsg")
                // }
                defaultOption={
                  <span className="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
                    {slicedMethod} - Default
                  </span>
                }
                ariaLabel="Ordering paymentInfoDropdown/Notary"
                labelClassNames="questionnaire font-semibold w-[482px]"
                selectClassNames="custom__dropdown-wrapper w-[388px]"
                currentValue={
                  values && values[`paymentInfoDropdown_${index}`]
                    ? values[`paymentInfoDropdown_${index}`]
                    : null
                }
              />
            </div>
          </div>
          <button
            type="button"
            className="!h-[40px] btn__icon w-[275px]"
            onClick={() => {
              if (Array.isArray(showPaymentMethodForm)) {
                const updated = [...showPaymentMethodForm];
                let found = false;

                const newForm = updated.map((obj) => {
                  if (defaultMethod in obj) {
                    found = true;
                    return { [defaultMethod]: true };
                  }
                  return obj;
                });

                if (!found) {
                  newForm.push({ [defaultMethod]: true });
                }

                setShowPaymentMethodForm(newForm);
              } else {
                setShowPaymentMethodForm([{ [defaultMethod]: true }]);
              }
              dropdownChange({}, index);
              if (defaultMethod?.trim() === "EFT") {
                setEftPaymentReq(false);
              } else if (defaultMethod?.trim() === "Cheque") {
                setChequePaymentReq(false);
              }
            }}
          >
            <span>Use different payment method</span>
          </button>
        </div>
      ) : (
        <div className=" mt-[24px] px-[40px]" id="show_payment_method">
          {/* <div id="payment_added" aria-labelledby="payment_added">
            <form
              id="payment_type"
              name="paymentTypeForm"
              className="custom__radio mb-[24px]"
            >
              <input
                id="radio_credit_card"
                className="custom__radio"
                type="radio"
                name="paymentType"
                onChange={(event) => {
                  setPaymentMethodType(event.target.value);
                }}
                value="creditCard"
                checked={paymentMethodType === "creditCard"}
              />
              <label className="cursor-pointer" for="radio_credit_card">
                Credit Card
              </label>
              <input
                id="radio_etf"
                className="custom__radio"
                type="radio"
                name="paymentType"
                onChange={(event) => {
                  setPaymentMethodType(event.target.value);
                }}
                value="eft"
                checked={paymentMethodType === "eft"}
              />
              <label className="cursor-pointer" for="radio_etf">
                EFT
              </label>
            </form>
          </div> */}
          {paymentMethodType === "creditCard" ? (
            <>
              <div
                className="gap-[10px] inline-flex w-max"
                style={{ marginLeft: "10px" }}
              >
                {/* <div className="!w-[130px] input-container mt-[25px] relative">
                  <p className="font-semibold">Credit Card</p>
                </div> */}
                <div className="w-[736px] input-container">
                  <label
                    htmlFor="regular-input"
                    className="block font-semibold input-label mb-2"
                  >
                    Credit Card Number
                  </label>
                  {/* <input
                    className="opacity-5"
                    type="text"
                    // {...register(`credit.cardnumber`)}
                    name={`credit.cardnumber`}
                    disabled={true}
                  />
                  <svg
                    class="-translate-y-1/2 absolute input-icon mt-[30px] right-3 transform"
                    width="25"
                    height="25"
                    fill="none"
                  >
                    <path
                      d="M20.404 11.428s.33 1.614.403 1.953h-1.45c.144-.387.695-1.888.695-1.888-.009.013.143-.395.23-.647l.122.582ZM25 4.86v15.277c0 1.15-.933 2.084-2.083 2.084H2.083A2.084 2.084 0 0 1 0 20.138V4.862c0-1.15.933-2.084 2.083-2.084h20.834c1.15 0 2.083.933 2.083 2.084ZM6.619 15.763l2.743-6.736H7.517l-1.705 4.601-.187-.933-.608-3.1c-.1-.429-.408-.55-.79-.568H1.42l-.03.135a6.888 6.888 0 0 1 1.831.742l1.554 5.86H6.62Zm4.097.01 1.094-6.746h-1.745l-1.09 6.745h1.741Zm6.072-2.206c.009-.768-.46-1.354-1.463-1.836-.611-.308-.985-.516-.985-.833.009-.287.317-.582 1.003-.582a2.99 2.99 0 0 1 1.298.256l.156.074.239-1.458a4.335 4.335 0 0 0-1.563-.287c-1.723 0-2.934.92-2.943 2.231-.013.968.868 1.507 1.528 1.832.673.33.903.547.903.838-.009.451-.547.66-1.046.66-.694 0-1.068-.11-1.636-.36l-.23-.11-.243 1.515c.408.187 1.163.352 1.944.36 1.832.005 3.025-.902 3.038-2.3Zm6.129 2.205L21.51 9.027h-1.35c-.416 0-.733.122-.91.56l-2.592 6.185h1.832l.364-1.011h2.24c.052.239.208 1.011.208 1.011h1.615Z"
                      fill="#000"
                    ></path>
                  </svg> */}
                </div>
                <div className="size__xxs input-container">
                  <label
                    htmlFor="regular-input"
                    className="block font-semibold input-label mb-2"
                    style={{ marginLeft: "140%" }}
                  >
                    Expiry Date
                  </label>
                  {/* <input
                    className="opacity-5"
                    type="text"
                    // {...register(`credit.expDate`)}
                    name={`credit.expDate`}
                    disabled={true}
                  ></input> */}
                </div>
                <div className="size__xxs input-container">
                  <label
                    htmlFor="regular-input"
                    className="block font-semibold input-label mb-2"
                    style={{ marginLeft: "140%" }}
                  >
                    CVV
                  </label>
                  {/* <input
                    className="opacity-5"
                    type="text"
                    // {...register(`credit.CVV`)}
                    name={`credit.CVV`}
                    disabled={true}
                  ></input> */}
                </div>
              </div>
              <div
                className="gap-[10px] inline-flex"
                id="show_credit_card"
                style={{ marginTop: "-10px" }}
              >
                {/* <div className="flex gap-[16px] items-end">
                <div className="relative w-[240px]">
                  <label for="credit_card" className="block font-semibold mb-2">
                    Credit Card Number
                  </label>
                  <input
                    type="text"
                    id="credit_card"
                    placeholder="0000 0000 0000 0001"
                    className="!pr-[40px]"
                  />
                  <item
                    src="../../master-logo.6776db2f.svg"
                    alt="VISA Logo"
                    className="absolute right-[12px] top-[42px]"
                    aria-hidden="true"
                  />
                </div>
                <div className="w-[90px]">
                  <label
                    for="expiry_date_input"
                    className="block font-semibold mb-2"
                  >
                    Expiry date
                  </label>
                  <input
                    type="text"
                    id="expiry_date_input"
                    placeholder="MM/YY"
                  />
                </div>
                <div className="w-[93px]">
                  <label for="cvv_input" className="block font-semibold mb-2">
                    CVV
                  </label>
                  <input type="text" id="cvv_input" placeholder="000" />
                </div>
              </div> */}

                <div className="flex flex-col mt-[10px]">
                  <div
                    id="monerisResponse"
                    className="flex flex-row"
                    style={{ height: "40px" }}
                  >
                    <iframe
                      title="title"
                      id={`monerisFrame${index}`}
                      src={`https://esqa.moneris.com/HPPtoken/index.php?${iQuery}`}
                      frameBorder="0"
                      height="100"
                      width={790}
                      // ref={iframeRef}
                      ref={(el) => (iframeRef.current[index] = el)}
                    />

                    <div
                      className="flex justify-end w-[600px]"
                      style={{ marginLeft: "-145px" }}
                    >
                      <button
                        onClick={() => {
                          setShowPaymentMethodForm(
                            showPaymentMethodForm.map((item) =>
                              defaultMethod in item
                                ? { [defaultMethod]: false }
                                : item,
                            ),
                          );
                          if (defaultMethod === "EFT") {
                            setEftPaymentReq(true);
                          } else if (defaultMethod === "Cheque") {
                            setChequePaymentReq(true);
                          }
                        }}
                        className="break-keep focus-visible:bg-[#ECECEC] h-[20px] py-[9px] rounded-sm text-[#595959] text-center w-[80px]"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  <div className="flex flex-row">
                    {CCerror && CCerror[paymentMethod] && (
                      <span className="font-semibold text-secondary-red">
                        {getErrorMessage(CCerror[paymentMethod].code)}
                      </span>
                    )}
                  </div>
                </div>

                {/* <PaymentToken
                  id={`monerisFrame1`}
                  ref={submissionRef}
                  setTokenKey={(token, binValue) => {
                    // handlDropdownChange(`credit.${index}.bin`, binValue);
                    setToken(token);
                    // trigger(`credit.${index}.waltID`);
                  }}
                  firmIDAndName={`firmIDAndName`}
                  billing={`billing`}
                  setCCDailog={setCCDialog}
                  setCreditCardRequest={setCreditCardRequest}
                  values={values}
                  billingValues={"Lawyer"}
                  index={1}
                  setShowPaymentMethodForm={(val) =>
                    setShowPaymentMethodForm(val)
                  }
                  defaultMethod={defaultMethod}
                  setAltPaymentReq={(val) => setAltPaymentReq(val)}
                  setEftPaymentReq={(val) => setEftPaymentReq(val)}
                  setChequePaymentReq={(val) => setChequePaymentReq(val)}
                  invoices
                /> */}

                {/* <div>
                <button
                  className="break-keep focus-visible:bg-[#ECECEC] h-[40px] hover:bg-[#ECECEC] py-[9px] rounded-sm text-[#595959] text-center w-[80px]"
                  id="cancel_quote_button"
                  type="button"
                  onClick={() => setShowPaymentMethodForm(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn__primary h-[40px] px-[16px] py-[9px] w-[68px]"
                  type="button"
                  onClick="savePaymentMethod()"
                >
                  Save
                </button>
              </div> */}
              </div>
            </>
          ) : (
            <div className="flex items-end justify-between" id="show_eft">
              <div className="flex gap-[16px] items-end">
                <div className="w-[90px]">
                  <label
                    for="transit_number"
                    className="block font-semibold mb-2"
                  >
                    Transit #
                  </label>
                  <input type="text" id="transit_number" placeholder="12345" />
                </div>
                <div className="w-[90px]">
                  <label for="bank_number" className="block font-semibold mb-2">
                    Bank #
                  </label>
                  <input type="text" id="bank_number" placeholder="456" />
                </div>
                <div className="w-[234px]">
                  <label
                    for="account_number"
                    className="block font-semibold mb-2"
                  >
                    Account #
                  </label>
                  <input
                    type="text"
                    id="account_number"
                    placeholder="1234567"
                  />
                </div>
              </div>
              <div>
                <button
                  className="break-keep focus-visible:bg-[#ECECEC] h-[40px] hover:bg-[#ECECEC] py-[9px] rounded-sm text-[#595959] text-center w-[80px]"
                  id="cancel_quote_button"
                  type="button"
                  onClick={() => {
                    setShowPaymentMethodForm(
                      showPaymentMethodForm.map((item) =>
                        defaultMethod in item
                          ? { [defaultMethod]: false }
                          : item,
                      ),
                    );
                    if (defaultMethod === "EFT") {
                      setEftPaymentReq(false);
                    } else if (defaultMethod === "Cheque") {
                      setChequePaymentReq(false);
                    }
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn__primary h-[40px] px-[16px] py-[9px] w-[68px]"
                  type="button"
                  onClick="savePaymentMethod()"
                >
                  Save
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(PaymentSelection);
